export default __webpack_public_path__ + "static/media/profile-img.23977f23.jpg";